import React from "react";
import PropTypes from "prop-types";
import Checkbox from "lib/common/controls/Checkbox";

const Body = props =>
    <React.Fragment>
        <Checkbox
            label="Enable Default Search: Checking this box allows you to save a default search that will be loaded upon logging in."
            shortname="useDefaultSearch"
            value={props.defaultSearch.enabled}
            onCommitChange={props.updateDefaultSearchEnablement}
        />
    </React.Fragment>;

Body.propTypes = {
    defaultSearch: PropTypes.shape({
        enabled: PropTypes.bool.isRequired,
        query: PropTypes.object,
    }).isRequired,
    updateDefaultSearchEnablement: PropTypes.func.isRequired,
};

export default Body;



// WEBPACK FOOTER //
// ./app/lib/preferences/Body.js